
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severe-weather-climate",
      function () {
        return require("private-next-pages/severe-weather-climate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severe-weather-climate"])
      });
    }
  